import LLMLogPopup from 'app/concierge/LLMLogPopup';

export default function ConciergeLLMLogWrapper({ props }: { props: any }) {
    return <LLMLogPopup sessionUid={props.session_uid} />;
}
